import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { DevelopmentRequestService } from '../../../service/development-request/development-request.service';
import { DevelopmentRequest } from '../../../class/development-request';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { Message, FileUpload } from 'primeng/primeng';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { config } from '../../../../../../environments/config';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';
@Component({
  selector: 'app-new-development-requests',
  templateUrl: './new-development-requests.component.html',
  styleUrls: ['./new-development-requests.component.scss']
})
export class NewDevelopmentRequestsComponent implements OnInit, OnChanges {

  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  // @Input() edit: DevelopmentRequest;
  @Input() verification: boolean;
  @Input() gestionSac: any;
  @Input() subPagePath: string;

  public promiseForm: Promise<any>;
  public form: FormGroup;

  public comp_report_by_id: String;

  public es: any;

  public type_problemOptions: SelectItem[];
  public priorityOptions: SelectItem[];
  public statusOptions: {label: string, value: string, selected: boolean, disabled: boolean}[];

  public myEmployeeId: string;

  public report_by_id: any = null;
  public employee_id: number = null;
  public venue_id: number = null;

  public disabledSolution: boolean;
  public disabledReportUser: boolean;

  public apiUrl = config.API_ROOT;
  public msgs: Message[];

  public uploadedFileDescription: any[] = [];
  public prewiewFileDescription: any;
  public promiseFileDescription: Promise<any>;

  public uploadedFileAnswer_solution: any[] = [];
  public prewiewFileAnswer_solution: any;
  public promiseFileAnswer_solution: Promise<any>;
  private id: number;
  public edit: DevelopmentRequest;

  public loading: boolean = false;
  public doRequest: number = 0;

  constructor(
    public fb: FormBuilder,
    public developmentRequestService: DevelopmentRequestService,
    public translate: TranslateService,
    private ngZone: NgZone,
    private notificationsService: NotificationsService,
    private mapsAPILoader: MapsAPILoader,
    public uploadFilesService: UploadFilesService,
    public hasPermissionService: HasPermissionService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.disabledSolution = false;
    this.disabledReportUser = true;

    this.es = calendarES();

    this.type_problemOptions = [
      // {label: 'choose', value: ''},
      {label: 'Queja', value: 'Queja'},
      {label: 'Solicitud', value: 'Solicitud'},
      {label: 'Felicitación', value: 'Felicitación'}
    ];

    this.priorityOptions = [
      // {label: 'choose', value: ''},
      {label: 'Alta', value: 'Alta'},
      {label: 'Media', value: 'Media'},
      {label: 'Baja', value: 'Baja'},
    ];

    this.statusOptions = [
      {label: 'Por hacer', value: 'Por hacer', selected: true, disabled: false},
      {label: 'Programado', value: 'Programado', selected: false, disabled: false},
      {label: 'En ejecución', value: 'En ejecución', selected: false, disabled: false},
      {label: 'Cerrado', value: 'Cerrado', selected: false, disabled: false},
      {label: 'No aplica', value: 'No aplica', selected: false, disabled: false},
    ];
  }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get('id');
    
    if(this.id !== 0 && (this.id !== undefined)){
      var promiseLoc = this.developmentRequestService.infoDevReq(this.id).toPromise().then(
        response =>{
          this.edit = response.json();
          this.report_by_id = this.edit.report_by_id;
          this.createForm(this.edit);
          this.doRequest = 1;
        },
        error=>{
          this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
          this.router.navigateByUrl('/pages/innvovation/development-requests');
          // this.doRequest = 1;
        }
      );
    }
    else{
      this.employee_id = JSON.parse(localStorage.getItem('profile')).employee_id;
      this.report_by_id = this.employee_id;
      this.createForm();
      this.doRequest = 1;
    }


    // if (this.edit) {
    //   this.editValues();
    // }
  }

  ngOnChanges(){
    //this.ngOnInit();
  }

  createForm(data:any = null){
    data = data || {
      id: undefined,
      report_by_id: null,
      venue_id: '',
      company_id: null,
      type_problem: '',
      typification_id: null,
      description: null,
      answer_solution: null,
      priority: '',
      created_at: null,
      date_solution: null,
      date_process: null,
      days: null,
      status: null,
      objective: null,
      date_pprocess: null,
      date_psolution: null,
      methodology: null,
      testing: null,
    };

    this.form = this.fb.group({
      id: [ data.id ],
      report_by_id: [ data.report_by_id, Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      venue_id: [ data.venue_id, Validators.compose([ Validators.minLength(1) ]) ],
      company_id: [ data.company_id, Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      type_problem: [ {value: data.type_problem, disabled: this.edit}, Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      typification_id: [ data.typification_id ],
      description: [ {value: data.description, disabled: this.edit}, Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      answer_solution: [ data.answer_solution ],
      priority: [ {value: data.priority, disabled: this.edit}, Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      created_at: [ data.created_at ? new Date(data.created_at) : new Date() ],
      date_solution: [ data.date_solution ? new Date(data.date_solution) : null ],
      date_process: [ data.date_process ? new Date(data.date_process) : null ],
      days: [ data.days ],
      status: [ data.status ],
      objective: [ {value: data.objective, disabled: this.edit}, Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      date_pprocess: [ data.date_pprocess ? new Date(data.date_pprocess) : null ],
      date_psolution: [ data.date_psolution ? new Date(data.date_psolution) : null ],
      methodology: [ data.methodology ],
      testing: [ data.testing ],
    });
  }

  public cancelDevReq () {
    this.form.reset();
    this.close.emit(true);
  }

  public newDevReq(values) {
    values.id = values.id == null ? undefined : values.id;

    if (!values.status)
      values.status = 'Por hacer';

    if (values.report_by_id) {
      if(values.report_by_id.id)
        values.report_by_id = values.report_by_id.id;
      else
        values.report_by_id = values.report_by_id;
    } else
      values.report_by_id = this.edit.report_by_id;

    values.created_at = formatDate(values.created_at);

    if (this.edit){
      // if ((this.edit.created_at == null || this.edit.created_at == '') && (values.statusvalues.status == ''))
      //   values.created_at = formatDate(new Date());
      // else if (this.edit.created_at)
      //   values.created_at = formatDate(this.edit.created_at);

      if (this.edit.objective)
        values.objective = this.edit.objective;

      if (this.edit.description)
        values.description = this.edit.description;

      if (this.edit.priority)
        values.priority = this.edit.priority;

      if (this.edit.type_problem)
        values.type_problem = this.edit.type_problem;

      if (this.edit.venue_id)
        values.venue_id = this.edit.venue_id;

      if ((this.edit.date_process == null || this.edit.date_process == '') && values.status == 'En ejecución')
        values.date_process = formatDate(new Date());
      else if (this.edit.date_process)
        values.date_process = formatDate(this.edit.date_process);

      if ((this.edit.date_solution == null || this.edit.date_solution == '') && (values.status == 'Cerrado' || values.status == 'No aplica'))
        values.date_solution = formatDate(new Date());
      else if (this.edit.date_solution)
        values.date_solution = formatDate(this.edit.date_solution);
    } else {
      values.venue_id = this.venue_id;
    }

    values.company_id = values.company_id ? values.company_id.id : this.edit.company_id;
    values.date_pprocess = (values.date_pprocess != '' && values.date_pprocess != null) ? formatDate(values.date_pprocess ): null;
    values.date_psolution = (values.date_psolution != '' && values.date_psolution != null) ? formatDate(values.date_psolution ): null;

    if (values && this.form.valid) {
      this.loading = true;
      const promise = (this.edit) ? this.developmentRequestService.updateDevReq(this.edit.id, values) : this.developmentRequestService.newDevReq(values);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
            this.edit = response.json();
            // this.msg.emit( { severity: 'success', summary: res  } );
            this.close.emit(true);
            this.form.reset();
          });
          this.router.navigateByUrl('/pages/innovation/development-requests');
        },
        error => {
          this.loading = false;
          let msg = '';
          this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
            this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
              JSON.parse(error._body).errors.forEach(element => {
                if (element.source) {
                  if (element.source.pointer) {
                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                      msg = msg + res3 + ', ';
                    });
                  }
                }
              });
              this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
              // this.msg.emit( { severity: 'error', summary: 'Error' } );
            });
          });
        }
      );
    }
  }

  getFormValidationErrors(form) {
    let value = '';
    Object.keys(form.controls).forEach(key => {
      const controlErrors: ValidationErrors = form.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
        });
      }
    });
    return (value);
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public checkOtherValidation (values) {
    let check = false;
    if (!this.edit) {
      if (values) {
        if (values.report_by_id) {
          if (values.report_by_id.id) {
            check = true;
          } else {
            return false;
          }
        }
        if (values.company_id || this.gestionSac.company_id) {
          if (values.company_id.id || this.gestionSac.company_id) {
            check = true;
          } else {
            return false;
          }
        }
      }
    } else {
      if(!this.verification) {
        if (values) {
          if (values.worked_by_id) {
            if (values.worked_by_id.id) {
              check = true;
            } else {
              return false;
            }
          } else {
            check = true;
          }
          if(values.status == "Solucionada" || values.status == "Cerrada") {
            if((values.answer_solution =='' || values.answer_solution ==null))
              check = false;
            else
              check = true;
          }
        }
      } else {
        check = true;
      }
    }
    return check;
  }

  public onUploadFileDescription(event: any) {
    this.uploadedFileDescription = [];
    for (const file of event.srcElement.files) {
      this.uploadedFileDescription.push(file);
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewFileDescription = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateFileDescription(event: any) {
    this.uploadedFileDescription = [];
    for (const file of event.files) {
      this.uploadedFileDescription.push(file);
    }

    this.promiseFileDescription = this.uploadFilesService.updateFileDescription(this.uploadedFileDescription, this.edit.id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push( { severity: 'success', summary: res } );
        });
        // this.getProfile();
        // this.avatar = this.prewiewFileDescription;
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: errorMsg } );
      }
    );
  }

  public hasRole(rol){
    var r: boolean=false;
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    if(role == rol){
      r = true;
    }
    return (r);
  }

  public uploadDataFromCreatedById(event) {
    this.form.get('venue_id').setValue('');
    this.venue_id = event.venue_id;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/development-requests/new-development-requests/new-development-requests.component.ts